import {createFileRoute} from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {ROLES} from "@/lib/auth/roles";
import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import Advisers from "@/modules/advisers/advisers-table";
import {advisersQueryOptions} from "@/modules/advisers/advisers-table/hooks";
import {
  AdviserSearch,
  defaultFetchParamsAdviser,
  mergedAdviserSchema,
} from "@/types/route-search-schemas";
import {DataLoader} from "@/types/router-context";
import {ADVISERS_PATH, ADVISERS_URL} from "@/utils/urls";

export const Route = createFileRoute(ADVISERS_PATH)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): AdviserSearch => validateSearchWithDefaults(mergedAdviserSchema, search),

  loader: ({ context: { queryClient} }: DataLoader) => {
    if (isCurrentPage(ADVISERS_URL)) {
      return
    }
    return queryClient.prefetchQuery(advisersQueryOptions(defaultFetchParamsAdviser))
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        {label: 'Home', path: '/'},
        {label: 'Advisers', path: ADVISERS_URL},
      ],
      children: <div className={'h-10'}></div>
    }
  }
})

function RouteComponent() {
  return (
    <div className={'flex flex-col items-left justify-center max-sm:p-5'}>
      <Authorisation
        roles={[ROLES.ROLE_VIEW_ADVISER, ROLES.ROLE_VIEW_FIRM]}
        permissions={[]}
        forbiddenFallback={<Unauthorized/>}>
        <Advisers/>
      </Authorisation>
    </div>
  )
}
